import { createFileRoute, Link } from '@tanstack/react-router'
import { useForm } from '@tanstack/react-form'
import UserSay from '@/components/UserSay'
import { ArrowLeft, Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/new-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ForgotPassword />
}

function ForgotPassword() {
  const { t } = useTranslation()
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false)

  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
    onSubmit: async ({}) => {
      try {
        // mutate(value)
      } catch (error) {
        // console.error(t('routes.new-password.errors.submission-error'), error)
      }
    },
  })

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev)
  }

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible((prev) => !prev)
  }

  return (
    <div className="flex h-screen mt-[1px]">
      {/* Left side form */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md space-y-8 px-4 mt-[-250px]">
          <UserSay
            blueWord={t('routes.new-password.title.blue-word')}
            title={t('routes.new-password.title.main')}
            description={t('routes.new-password.title.description')}
          />
          <form
            onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              form.handleSubmit()
            }}
            className="space-y-6"
          >
            <div className="space-y-4">
              <div>
                <form.Field
                  name="password"
                  children={(field) => (
                    <div className="relative">
                      <input
                        name={field.name}
                        value={field.state.value}
                        onBlur={field.handleBlur}
                        onChange={(e) => field.handleChange(e.target.value)}
                        type={isPasswordVisible ? 'text' : 'password'}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        placeholder={t(
                          'routes.new-password.form.inputs.new-password'
                        )}
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                      >
                        {isPasswordVisible ? (
                          <EyeOff size={20} />
                        ) : (
                          <Eye size={20} />
                        )}
                      </button>
                    </div>
                  )}
                />
              </div>
              <div>
                <form.Field
                  name="confirmPassword"
                  children={(field) => (
                    <div className="relative">
                      <input
                        name={field.name}
                        value={field.state.value}
                        onBlur={field.handleBlur}
                        onChange={(e) => field.handleChange(e.target.value)}
                        type={isConfirmPasswordVisible ? 'text' : 'password'}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        placeholder={t(
                          'routes.new-password.form.inputs.confirm-password'
                        )}
                      />
                      <button
                        type="button"
                        onClick={toggleConfirmPasswordVisibility}
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                      >
                        {isConfirmPasswordVisible ? (
                          <EyeOff size={20} />
                        ) : (
                          <Eye size={20} />
                        )}
                      </button>
                    </div>
                  )}
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-3xl shadow-sm text-sm font-medium text-white bg-[#FCD34D] hover:bg-[#F59E0B] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FCD34D]"
                >
                  {t('routes.new-password.form.button.submit')}
                </button>
                <div className="text-center mt-4">
                  <Link
                    to="/login"
                    className="inline-flex items-center gap-2 text-sm text-[#F59E0B] hover:text-[#FCD34D] font-medium"
                  >
                    <ArrowLeft size={16} />
                    {t('routes.new-password.form.back-to-login')}
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Right side image for lg screens */}
      <div className="hidden lg:block lg:w-1/2 relative">
        <img
          src="/images/auth/signin.png"
          alt="Login"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </div>
  )
}

export default ForgotPassword
